import { SxProps, Theme, Box, styled } from '@mui/material';
import React, { ReactNode } from 'react';
import styles from './Circle5.module.scss';

type Circle5Props = {
    children?: ReactNode | undefined,
    sx?: SxProps<Theme>,
    className?: string,
};

const Circle5Layout = styled(Box)(({ theme }) => ({

}));

const Circle5 = (props: Circle5Props) => {
    const { sx, className } = props;

    return (
        <Circle5Layout className={`${styles.Circle5} ${className || ""}`} sx={sx} data-testid="Circle5" data-aos="zoom-in" />
    );
};

export default Circle5;
